module.exports = __webpack_public_path__ + "img/success.cb26f6fa.png";